/**
 * `area_sqm` ist keine Geldsumme — `lib/money.ts` ist der falsche Ort dafür.
 * Trotzdem dasselbe Problem im Kleinen: Die API liefert und erwartet eine
 * kanonische Dezimalzeichenkette mit Punkt (`"1200.00"`), das Eingabefeld
 * folgt wie jedes Zahlenfeld dieser Anwendung der deutschen Schreibweise mit
 * Komma (`design-system`, `inputMode="decimal"`).
 */

/** `"1200.00"` → `"1200,00"`, fürs Formularfeld. */
export function areaToInputValue(areaSqm: string): string {
  return areaSqm.replace('.', ',')
}

/**
 * Eingabe mit Komma oder Punkt zur kanonischen Punkt-Zeichenkette, die die
 * API erwartet. `null` bei leerer Eingabe — die Fläche ist optional. Die
 * eigentliche Prüfung (höchstens zwei Nachkommastellen, nicht negativ)
 * bleibt beim Server; ein ungültiger Wert kommt als Feldfehler zurück
 * (`field: area_sqm`), nicht als Client-Validierung.
 */
export function parseAreaInput(input: string): string | null {
  const trimmed = input.trim()
  if (trimmed === '') return null

  return trimmed.replace(',', '.')
}
